import { AccordionPassThroughOptions } from 'primereact/accordion'
import { classNames } from 'primereact/utils'
import { TRANSITIONS } from './transitions'

export const accordionConfig: AccordionPassThroughOptions = {
  root: {
    className: 'mk-accordion',
  },
  accordiontab: {
    header: {
      className: classNames('mk-accordion__tab'),
    },
    content: {
      className: 'mk-accordion__content',
    },
    transition: TRANSITIONS.toggleable,
  },
}
